import { useUpdateCheck } from "@/hooks/use-update-check";
import { useI18n } from "@/hooks/use-i18n";
import { RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function UpdateBanner() {
  const { updateAvailable, refresh, dismiss } = useUpdateCheck();
  const { t } = useI18n();

  if (!updateAvailable) return null;

  return (
    <div className="sticky top-0 z-[70] flex items-center justify-center gap-3 px-4 py-2 text-sm font-medium bg-primary text-primary-foreground">
      <RefreshCw className="h-4 w-4" />
      <span>{t("updateAvailable")}</span>
      <Button
        size="sm"
        variant="secondary"
        className="h-7 px-3 text-xs"
        onClick={refresh}
      >
        {t("updateNow")}
      </Button>
      <button onClick={dismiss} className="ml-1 p-1 rounded hover:bg-white/20 transition-colors">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
